import {  Transform } from '../4d-objects';
import { from, of } from 'rxjs';
import {  Renderer,PlottableReference } from '../renderer'

const Cesium = (<any>window).Cesium


/**
 * A really really crude implmentation bease off this code someone wrote
 * https://github.com/sushrut141/Cesium-WebFeatureService
 * 
 */
export class WFSTransformRenderer extends Renderer<Transform>{

  constructor(private viewer:any){
    super()
    this._log();
  }
  addedCache = []
  onAdd(t:Transform, args?:any){

    this.addedCache = []
    var layer = t['proxyMeta'].layer_id
  
    this._log('onAdd',[t,args, layer]);

    if(args && args.onInit) { args.onInit(t,{layer}); }

    var file = t.file('WFS') + '&request=GetFeature&typeName=' + layer + '&maxFeatures=100';

    if(args && args.onStart) { args.onStart(t,file); }

    return from(fetch(file).then(r => r.text()).then(txt => {

      var parser = new DOMParser();
      var gml = parser.parseFromString(txt,'application/xml');
      var res = processFeatureCollection({_featureMap:{},_viewer:this.viewer}, gml)

      if(args && args.onProcess) { args.onProcess(t,res); }

      res.map(r => 
        r.map(rr => 
          rr.map(rrr => {
            let e = this.viewer.entities.add(rrr);
            if(args && args.onDuring) { args.onDuring(t,e); }
            this.addedCache.push(e)
          })
        )
      )

      if(args && args.onEnd) { args.onEnd(t,this.addedCache); }

      return {
        plottable:t,
        object:this.addedCache
      }
    }))
  
  
  }
  onRemove(t:Transform,pr:PlottableReference){
    pr.object.map(a => this.viewer.entities.remove(a))
    
  }
}





var PolygonHierarchy = Cesium.PolygonHierarchy
var Maths = Cesium.Math
var Color = Cesium.Color
var PinBuilder = Cesium.PinBuilder
var Cartographic = Cesium.Cartographic
var Cartesian3 = Cesium.Cartesian3
var Ellipsoid = Cesium.Ellipsoid
var PolylineCollection = Cesium.PolylineCollection
var BillboardCollection = Cesium.BillboardCollection
var Polygon = Cesium.PolygonGeometry

function defaultCrsFunction(coordinates) {
  return Cartesian3.fromDegrees(coordinates[0], coordinates[1], coordinates[2]);
}

var crsNames = {
  'EPSG:4326' : defaultCrsFunction,
  'urn:ogc:def:crs:EPSG::4326' : defaultCrsFunction,
  'urn:ogc:def:crs:EPSG:6.6:4326' : defaultCrsFunction,
  'http://www.opengis.net/gml/srs/epsg.xml#4326' : defaultCrsFunction
};

var sizes = {
  small : 24,
  medium : 48,
  large : 64
};

var geometryPropertyTypes = {
  Point : processPoint,
  MultiPoint : processMultiPoint,
  LineString : processLineString,
  MultiLineString : processMultiLineString,
  Polygon : processPolygon,
  MultiPolygon : processMultiPolygon,
  MultiSurface : processMultiSurface,
};

var surfacePropertyTypes = {
  Polygon : processPolygon,
  Surface : processSurface
};

var surfaceBoundaryTypes = {
  LinearRing : processLinearRing,
  Ring : processRing
};

var gmlns = "http://www.opengis.net/gml";

function getCrsProperties(node, crsProperties) {
  var crsName = node.getAttribute('srsName');
  if(crsName) {
      var crsFunction = crsNames[crsName];
      if(!crsFunction) {
          return Error('Unknown crs name: ' + crsName);
      }
      crsProperties.crsFunction = crsFunction;
  }

      var crsDimension = node.getAttribute('srsDimension');
      if(crsDimension) {
          crsDimension = parseInt(crsDimension);
          crsProperties.crsDimension = crsDimension;
      }
  return crsProperties;
}


function processFeatureCollection(that,gml) {

  var documentNode = gml.documentElement;
  var featureCollection = documentNode.getElementsByTagNameNS(gmlns, "featureMember");
  if(featureCollection.length == 0) {
      featureCollection = documentNode.getElementsByTagNameNS(gmlns, "featureMembers");
  }

  var crsProperties = {'crsFunction' : defaultCrsFunction, 'crsDimension' : 2};
      var boundedByNode = documentNode.getElementsByTagNameNS(gmlns, "boundedBy")[0];
  if(boundedByNode) {
      crsProperties = getCrsProperties(boundedByNode.firstElementChild, crsProperties);
  }
  var res = []
  for(var i = 0; i < featureCollection.length; i++) {
      var features = featureCollection[i].children;
      for(var j = 0; j < features.length; j++) {
          res.push( processFeature(that,features[j], crsProperties) );
      }
  }
  return res;
}


function processFeature(that,feature, crsProperties) {

  /*
  when using tiled startegy features need to be rendered again 
  even if they were previously rendered as they have been removied from the 
  primitive collection

  if(!that._tiled){
      var featureText = feature.attributes && feature.attributes['gml:id'] ? feature.attributes['gml:id'].nodeValue:'' + Math.random()
      var featureID = featureText;
      if(that._featureMap[featureID])
          return;
      else
          that._featureMap[featureID] = feature.attributes[0].textContent;
  }  */

  var i, j, geometryHandler, geometryElements = [];
  var crsFunction = defaultCrsFunction;
  var properties = {};

      var boundedByNode = feature.getElementsByTagNameNS(gmlns, "boundedBy")[0];
      if(boundedByNode) {
          crsProperties = getCrsProperties(feature.firstElementChild, crsProperties);
          feature.removeChild(boundedByNode);
      }

      var elements = feature.children;
      for(i = 0; i < elements.length; i++) {
          var childCount = elements[i].childElementCount;
          if(childCount == 0) {
              //Non-nested non-spatial properties.
              properties[elements[i].localName] = elements[i].textContent;
          } else if(childCount > 0) {
              //Nested and geometry properties.
              var subElements = elements[i].children;
              var prop = {};
              for(j = 0; j < childCount; j++) {
                  if(subElements[j].namespaceURI === gmlns) {
                      geometryElements.push(subElements[j]);
                  } else {
                      prop[subElements[j].localName] = subElements[j].textContent;
                  }
              }
              if(Object.keys(prop).length) {
                  properties[elements[i].localName] = prop;
              }
          }
      }
      var res = []
      for(i = 0; i < geometryElements.length; i++) {
        console.log('geom type ' + geometryElements[i].localName)
          geometryHandler = geometryPropertyTypes[geometryElements[i].localName];
          res.push(geometryHandler(that,geometryElements[i], properties, crsProperties));
      }
      return res;
}

function renderLineStringAsPolyline(that){
  var coords = [];
  for(var i = 0 ; i < that._coords.length/2;i++){
      var lat = parseFloat(that._coords[2*i]);
      var lng = parseFloat(that._coords[2*i + 1]);
      coords.push(lat,lng);
  }

  that._collectionVector.push(new PolylineCollection());
  var length = that._collectionVector.length;
  that._collectionVector[length - 1].add({
      positions : Cartesian3.fromDegreesArray(coords.slice(0)),
      width : 2.0,
      material: Cesium.Material.fromType('Color', {
          color: new Cesium.Color(1,0.8,0.2)
      }),
      show : true
  });
  that._viewer.scene.primitives.add(that._collectionVector[length - 1]); 
}

function processLineString(that,lineString, properties, crsProperties, index) {
  crsProperties = getCrsProperties(lineString, crsProperties);
  var coordString = lineString.firstElementChild.textContent;
  var splitCoords = coordString.split(" ");
  var coords_feature = [];
  that._coords.length = 0;
  //pushing lat/long values
  for(var i = 0 ; i < splitCoords.length; i++){
      var split = splitCoords[i].split(",");
      that._coords.push(split[0],split[1]);
  }
  /*that._coords.push({
      contour : index,
      positions : coords_feature.slice(0)
  });*/
  renderLineStringAsPolyline(that);


  //console.log(coordString);
  //var coordinates = processCoordinates(coordString, crsProperties);
  //createPolyline(coordinates, true, properties, crsProperties);
}

function processMultiLineString(that,multiLineString, properties, crsProperties) {
  crsProperties = getCrsProperties(multiLineString, crsProperties);
  var lineStringMembers = multiLineString.getElementsByTagNameNS(gmlns, "lineStringMember");
  if(lineStringMembers.length == 0) {
      lineStringMembers = multiLineString.getElementsByTagNameNS(gmlns, "lineStringMembers");
  }

  for(var i = 0; i < lineStringMembers.length; i++) {
      var lineStrings = lineStringMembers[i].children;
      for(var j = 0; j < lineStrings.length; j++) {
          processLineString(that,lineStrings[j], properties, crsProperties, j);
      }
  }
}

function renderPoint(that){
  var coords = [];
  for(var i = 0 ; i < that._coords.length/2;i++){
      var lat = parseFloat(that._coords[2*i]);
      var lng = parseFloat(that._coords[2*i + 1]);
      coords.push(lat,lng);
  }

  var cart = new Cartographic();
  cart.longitude = Maths.toRadians(coords[0]);
  cart.latitude = Maths.toRadians(coords[1]);
  cart.height = 0;

  var billBoardPosition = Ellipsoid.WGS84.cartographicToCartesian(cart);

  that._collectionVector.push(new BillboardCollection());
  var length = that._collectionVector.length;
  var builder = new PinBuilder();
  var color = new Color(0.0,1.0,1.0);
  that._collectionVector[length - 1].add({
      image : builder.fromColor(color,16).toDataURL(),
      position : billBoardPosition
  });
  that._viewer.scene.primitives.add(that._collectionVector[length - 1]);
}


function processPoint(that, point, properties, crsProperties) {
  crsProperties = getCrsProperties(point, crsProperties);
  var coordString = point.firstElementChild.textContent;
  var splitCoords = coordString.split(",");
  var coords_feature = [];
  that._coords.length = 0;
  //pushing lat/long values
  for(var i = 0 ; i < splitCoords.length; i++){
      that._coords.push(splitCoords[0],splitCoords[1]);
  }
  renderPoint(that);
}

function processMultiPoint(that, multiPoint, properties, crsProperties) {
  crsProperties = getCrsProperties(multiPoint, crsProperties);
  var pointMembers = multiPoint.getElementsByTagNameNS(gmlns, "pointMember");
  if(pointMembers.length == 0) {
      pointMembers = multiPoint.getElementsByTagNameNS(gmlns, "pointMembers");
  }

      for(var i = 0; i < pointMembers.length; i++) {
          var points = pointMembers[i].children;
          for(var j = 0; j < points.length; j++) {
              processPoint(that, points[j], properties, crsProperties);
          }
  }
}

function createPolygon(that, hierarchy, properties) {
  return {
    name: "Green extruded polygon",
    polygon: {
      hierarchy: hierarchy.positions,
      material: Cesium.Color.MAGENTA,
      closeTop: false,
      closeBottom: false,
      outline: true,
      outlineColor: Cesium.Color.MAGENTA,
    },
  };
}

function processPolygon(that, polygon, properties, crsProperties) {
  crsProperties = getCrsProperties(polygon, crsProperties);
  var exterior = polygon.getElementsByTagNameNS(gmlns, "exterior");
  var interior = polygon.getElementsByTagNameNS(gmlns, "interior");

  var surfaceBoundary;
  if(exterior.length == 0 && interior.length == 0) {
      surfaceBoundary = polygon.firstElementChild;
      surfaceBoundaryHandler = surfaceBoundaryTypes[surfaceBoundary.localName];
  }

  var holes = [], surfaceBoundaryHandler, surfaceBoundary, coordinates;
  for(var i = 0; i < interior.length; i++) {
      surfaceBoundary = interior[i].firstElementChild;
      surfaceBoundaryHandler = surfaceBoundaryTypes[surfaceBoundary.localName];
      holes.push(surfaceBoundaryHandler(that, surfaceBoundary, [], crsProperties));
  }

  if(exterior.length == 1) {
      exterior = exterior[0];
  }
  var surfaceBoundary = exterior.firstElementChild;
  surfaceBoundaryHandler = surfaceBoundaryTypes[surfaceBoundary.localName];
  that._hierarchy = surfaceBoundaryHandler(that, surfaceBoundary, holes, crsProperties);
  return createPolygon(that, that._hierarchy, properties);
}

function processMultiPolygon(that, multiPolygon, properties, crsProperties) {
  crsProperties = getCrsProperties(multiPolygon, crsProperties);
  var polygonMembers = multiPolygon.getElementsByTagNameNS(gmlns, "polygonMember");
  if(polygonMembers.length == 0) {
      polygonMembers = multiPolygon.getElementsByTagNameNS(gmlns, "polygonMembers");
  }
  for(var i = 0; i < polygonMembers.length; i++) {
      var polygons = polygonMembers[i].children;
      for(var j = 0; j < polygons.length; j++) {
          processPolygon(that, polygons[j], properties, crsProperties);
      }
  }
}

function processMultiSurface(that, multiPolygon, properties, crsProperties) {
  crsProperties = getCrsProperties(multiPolygon, crsProperties);
  var polygonMembers = multiPolygon.getElementsByTagNameNS(gmlns, "featureMember");
  if(polygonMembers.length == 0) {
      polygonMembers = multiPolygon.getElementsByTagNameNS(gmlns, "surfaceMember");
  }

  var res = []
  for(var i = 0; i < polygonMembers.length; i++) {
      var polygons = polygonMembers[i].children;
      for(var j = 0; j < polygons.length; j++) {
          res.push(processPolygon(that, polygons[j], properties, crsProperties));
      }
  }
  return res;
}


function processCoordinates(that,coordString) {
  var splitString = coordString.trim().split(" ");
  var coordinates = [];
  for(var i = 0 ; i < splitString.length;i+=2){
      coordinates.push(splitString[i + 1],splitString[i]);
  }
  return coordinates;
}   

function processLinearRing(that,linearRing, holes, crsProperties) {
  var coordString = linearRing.firstElementChild.textContent;
  var coords = processCoordinates(that,coordString);
  var ll_coords = [];
  for(var i = 0 ; i < coords.length; i++ ){
      ll_coords.push(parseFloat(coords[i]));
  }
  that._coords = Cartesian3.fromDegreesArray(ll_coords);

  var hierarchy = new PolygonHierarchy(that._coords, holes);
  return hierarchy;
}

//processRing works with only LineStringSegment. Does not work with Arc,
//CircleByCenterPoint and Circle. However, its very rare to find Arc,
//CircleByCenterPoint and Circle as part of a polygon boundary.
function processRing(ring, holes, crsProperties) {
  var curveMember = ring.firstElementChild.firstElementChild;
  var segments = curveMember.firstElementChild.children;
  var coordinates = [];
  for(var i = 0; i < segments.length; i++) {
      if(segments[i].localName === "LineStringSegment") {
          var coordString = segments[i].firstElementChild;
          coordinates.concat(processCoordinates({},coordString));
      } else {
          //Raise error.
      }
  }
  var hierarchy = new PolygonHierarchy(coordinates, holes);
  return hierarchy;
}

function processSurface(that, surface, properties, crsProperties) {
  crsProperties = getCrsProperties(surface, crsProperties);
  var patches = surface.firstElementChild.children;
  for(var i = 0; i < patches.length; i++) {
      processPolygon(that, patches[i], properties, crsProperties);
  }
}

/*
*   options = {
      url : "http://localhost:8080/geoserver/",
      layers : "namespace:layerName",
      featureID : feature id(depthContour.3438)(optional)
  };
*/

function compute(that){

  var width = that._viewer.scene.canvas.width;
  var height = that._viewer.scene.canvas.height;
  var sw = new Cesium.Cartesian2(0,height);

  var left = that._viewer.scene.camera.pickEllipsoid(sw,Ellipsoid.WGS84);
  if(!left){
      that._validBoundingBox = false;
      return;
  }

  var ne = new Cesium.Cartesian2(width,0);
  var right = that._viewer.scene.camera.pickEllipsoid(ne,Ellipsoid.WGS84);
      if(!right){
      that._validBoundingBox = false;
      return;
  }

  var elps = Ellipsoid.WGS84;

  var SW = elps.cartesianToCartographic(left);
  var NE = elps.cartesianToCartographic(right);

  that.S_W.lng = Cesium.Maths.toDegrees(SW.longitude);
  that.S_W.lat = Cesium.Maths.toDegrees(SW.latitude);

  that.N_E.lng = Cesium.Maths.toDegrees(NE.longitude);
  that.N_E.lat = Cesium.Maths.toDegrees(NE.latitude);

  that._validBoundingBox = true;

}  
